import { defineQuery } from '@rocicorp/zero';
import * as z from 'zod';
import { zql } from '../schema.js';
import { applyCursor } from '../util/apply-cursor.js';
import { Cursor, Sort } from './util.js';
export const ListUserGroupsFiltersInput = z.object({
    search: z.string().optional(),
    status: z.array(z.string()).optional(),
});
export const ListUserGroupsInput = z.object({
    filters: ListUserGroupsFiltersInput.optional(),
    limit: z.number().optional(),
    cursor: Cursor.extend({
        createdAt: z.number(),
        name: z.string(),
    }).optional(),
    sort: Sort.extend({
        field: z.string().default('createdAt'),
    }),
});
export const userGroupsQueries = {
    listUserGroups: defineQuery(ListUserGroupsInput, ({ args }) => {
        let q = zql.groups.where('deletedAt', 'IS', null).related('members', q => q.where('deletedAt', 'IS', null));
        if (args.filters) {
            const search = args.filters.search?.trim();
            if (search) {
                q = q.where(({ or, cmp }) => or(cmp('name', 'ILIKE', `%${search}%`), cmp('description', 'ILIKE', `%${search}%`)));
            }
        }
        q = applyCursor(q, { cursor: args.cursor, sort: args.sort, limit: args.limit });
        return q;
    }),
    getGroupById: defineQuery(z.string(), ({ args }) => {
        let q = zql.groups
            .related('members', q => q.where('deletedAt', 'IS', null).related('user'))
            .related('created')
            .where('id', args)
            .where('deletedAt', 'IS', null)
            .one();
        return q;
    }),
    getGroupActivitiesById: defineQuery(z.string(), ({ args }) => {
        return zql.eventLogs
            .related('actor')
            .where('resource', '=', 'group')
            .where('resourceId', '=', args)
            .orderBy('performedAt', 'desc');
    }),
};
//# sourceMappingURL=user-group.queries.js.map